import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type RouteDeliveryScheduleConfigDetailsFragment = { __typename?: 'RouteDeliveryScheduleConfigDocument', id: string, tenantId: string, entries: Array<{ __typename?: 'RouteDeliveryScheduleEntryDocument', routeCode: string, deliveryScheduleId: string, deliveryScheduleName: string, deliverySchedule?: { __typename?: 'DeliveryScheduleSummaryData', name: string, status: Types.DeliveryScheduleStatus, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null }> };

export type RouteDeliveryScheduleConfigStateDetailsFragment = { __typename?: 'RouteDeliveryScheduleConfigStateData', tenantId: string, entries: Array<{ __typename?: 'RouteDeliveryScheduleEntryData', routeCode: string, deliveryScheduleId: string }> };

export type GetRouteDeliveryScheduleConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRouteDeliveryScheduleConfigQuery = { __typename?: 'Query', routeDeliveryScheduleConfig?: { __typename?: 'RouteDeliveryScheduleConfigDocument', id: string, tenantId: string, entries: Array<{ __typename?: 'RouteDeliveryScheduleEntryDocument', routeCode: string, deliveryScheduleId: string, deliveryScheduleName: string, deliverySchedule?: { __typename?: 'DeliveryScheduleSummaryData', name: string, status: Types.DeliveryScheduleStatus, sunday: boolean, monday: boolean, tuesday: boolean, wednesday: boolean, thursday: boolean, friday: boolean, saturday: boolean } | null }> } | null };

export const RouteDeliveryScheduleConfigDetailsFragmentDoc = new TypedDocumentString(`
    fragment RouteDeliveryScheduleConfigDetails on RouteDeliveryScheduleConfigDocument {
  id
  tenantId
  entries {
    routeCode
    deliveryScheduleId
    deliveryScheduleName
    deliverySchedule {
      name
      status
      sunday
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
    }
  }
}
    `, {"fragmentName":"RouteDeliveryScheduleConfigDetails"});
export const RouteDeliveryScheduleConfigStateDetailsFragmentDoc = new TypedDocumentString(`
    fragment RouteDeliveryScheduleConfigStateDetails on RouteDeliveryScheduleConfigStateData {
  tenantId
  entries {
    routeCode
    deliveryScheduleId
  }
}
    `, {"fragmentName":"RouteDeliveryScheduleConfigStateDetails"});
export const GetRouteDeliveryScheduleConfigDocument = new TypedDocumentString(`
    query GetRouteDeliveryScheduleConfig {
  routeDeliveryScheduleConfig {
    ...RouteDeliveryScheduleConfigDetails
  }
}
    fragment RouteDeliveryScheduleConfigDetails on RouteDeliveryScheduleConfigDocument {
  id
  tenantId
  entries {
    routeCode
    deliveryScheduleId
    deliveryScheduleName
    deliverySchedule {
      name
      status
      sunday
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
    }
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetRouteDeliveryScheduleConfig: build.query<GetRouteDeliveryScheduleConfigQuery, GetRouteDeliveryScheduleConfigQueryVariables | void>({
      query: (variables) => ({ document: GetRouteDeliveryScheduleConfigDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetRouteDeliveryScheduleConfigQuery, useLazyGetRouteDeliveryScheduleConfigQuery } = injectedRtkApi;
